
export const ButtonVariants = ["main", "secondary", "link-primary", "link-secondary", "text", "main-reverse", "link-primary-reverse", "link-secondary-reverse"] as const;

export type ButtonVariant = typeof ButtonVariants[number];

export function isButtonVariant(variant: string): variant is ButtonVariant {
    return ButtonVariants.includes(variant as ButtonVariant);
};
